import React from "react";

import { RubbleTicket } from "../../interface/api/RubbleTicket";
import rubbleTicketService from "../../services/rubbleTicketService";
import SubStreamDriverForm from "../shared/sub-stream-driver-form";
import RubblePrintableTicket from "./rubble-printable-ticket";

const RubbleDriverForm = () => (
  <SubStreamDriverForm<RubbleTicket>
    service={rubbleTicketService}
    contractorFilter="isRubble"
    heading="RUBBLE"
    backgroundColor="#FFF3E0"
    streamRoute="rubble"
    PrintableTicket={RubblePrintableTicket}
  />
);

export default RubbleDriverForm;
